import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M957.44 445.44h-378.88V66.56c0-36.864-29.696-66.56-66.56-66.56S445.44 29.696 445.44 66.56v378.88H66.56c-36.864 0-66.56 29.696-66.56 66.56s29.696 66.56 66.56 66.56h378.88v378.88c0 36.864 29.696 66.56 66.56 66.56s66.56-29.696 66.56-66.56v-378.88h378.88c36.864 0 66.56-29.696 66.56-66.56s-29.696-66.56-66.56-66.56z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol